import { offerApi } from "api/TenantSlug/Offer/api.ts";

import GetOfferRequest = App.Http.Requests.Offer.GetOfferRequest;

export function composeGetOfferQueryOptions(offerId: string, request: GetOfferRequest) {
    return {
        queryKey: ["getOffer", offerId, request],
        queryFn: () => offerApi.show(offerId, request),
    };
}

export function getOfferQueryOptions(offerId: string, request: GetOfferRequest) {
    return {
        ...composeGetOfferQueryOptions(offerId, request),
        suspense: true,
    };
}
